import { registerLocale, getNames } from "i18n-iso-countries";
import enCountries from "i18n-iso-countries/langs/en.json";
import csCountries from "i18n-iso-countries/langs/cs.json";
import skCountries from "i18n-iso-countries/langs/sk.json";

registerLocale(enCountries);
registerLocale(csCountries);
registerLocale(skCountries);

export type CountryOption = {
  label: string;
  code: string;
};

export const getTranslatedCountries = (language?: string): CountryOption[] => {
  const lang = language || localStorage.getItem("i18nextLng") || "en";
  const countryNames = getNames(lang);

  return Object.keys(countryNames)
    .map((code) => ({
      label: countryNames[code],
      code,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
};
